export default "__VITE_ASSET__Cwwr_Ybt__"